import { Text } from "@otrium/atoms";
import Link from "next/link";
import { AdditionalCategoriesWrapper } from "./AdditionalCategories.styled";
import { useMemo } from "react";
import { NavigationItems } from "src/types/graphql.d";

type AdditionalCategoriesProps = {
  navigationItems?: NavigationItems | null;
};

function AdditionalCategories({
  navigationItems,
}: AdditionalCategoriesProps): JSX.Element | null {
  const categories = useMemo(
    () =>
      navigationItems?.navigation_links
        .filter((link) => !link.show_on_top)
        .slice(0, 4) || [],
    [navigationItems?.navigation_links]
  );

  if (!categories.length) {
    return null;
  }

  return (
    <AdditionalCategoriesWrapper>
      {categories.map((item) => (
        <li key={item.link}>
          <Link href={item.link}>
            <Text color={item.colour} fontWeight={600}>
              {item.title}
            </Text>
          </Link>
        </li>
      ))}
    </AdditionalCategoriesWrapper>
  );
}

export { AdditionalCategories };
